export default "__VITE_ASSET__DnVxOGSF__"